import CampaignIcon from "@mui/icons-material/Campaign";
import { CAMPAIGNS, ErasmusServicePath } from "utils/constants";
import { tenants } from "utils/tenants";
import ListCampaigns from "./List";
import permissions from "app/permissions";
import CreateCampaignForOutgoingStudents from "./Create";
import ShowCampaignForOutgoingStudents from "./Show/Show";

export const resources = {
  isMenu: true,
  icon: <CampaignIcon />,
  tenancies: [tenants.MU],
  name: `${ErasmusServicePath}${CAMPAIGNS}`,
  title: "Кампании",
  list: <ListCampaigns />,
  create: <CreateCampaignForOutgoingStudents />,
  show: <ShowCampaignForOutgoingStudents />,
  createPermission: permissions.canManageErasmusCampaigns,
  showPermission: permissions.canPreviewErasmusCampaigns,
  permission: permissions.canPreviewErasmusCampaigns,
};
